import React, { Suspense } from 'react';
import {InputSkeleton} from "../components/loading/input-skeleton";
const LazyDatepicker = React.lazy(() => import('../components/datepicker'));

export default function (dependencies) {
  const config = { validators: ['mandatory'] };

  const html = (props) => {
    const componentProps = { ...props, ...dependencies };
    return (
      <Suspense fallback={<InputSkeleton/>}>
        <LazyDatepicker {...componentProps}/>
      </Suspense>
    );
  };

  return { html, config };
}
